import { useTheme } from '@opallabs/hooks'
import { PlaceholderProps } from '../types'
import * as styles from './styles'

export { type PlaceholderProps as PlaceholderTextProps }

export const PlaceholderText = ({
  className,
  children,
}: PlaceholderProps): JSX.Element => {
  const theme = useTheme()

  return (
    <span className={className} css={styles.placeholderText(theme)}>
      {children}
    </span>
  )
}
PlaceholderText.displayName = 'Lapidary: PlaceholderText'
